import { inject, Injectable } from '@angular/core';
import { HarvestBlockService, MeasurementTypeService, ProductivityParameterGroupService, ProductivityParameterService, PropertyService } from 'cbd-proxies';
import { map, Observable } from 'rxjs';
import { DEFAULT_MAX_RESULT_COUNT, ZnSelectQueryParams } from '@zendra/shared';
import { ProductivityParameterGroupDto } from 'projects/cbd-proxies/src/lib/wood-supply/dtos/productivity-parameter-group';

@Injectable({
  providedIn: 'root',
})
export class HarvestPreparationCatalogs {
  private readonly propertyService = inject(PropertyService);
  private readonly harvestBlockService = inject(HarvestBlockService);
  private readonly measurementTypeService = inject(MeasurementTypeService);
  private readonly productivityParameterService = inject(ProductivityParameterService);
  private readonly productivityParameterGroupService = inject(ProductivityParameterGroupService);

  loadPropertyOptions(
    params?: ZnSelectQueryParams
  ): Observable<{ items: { key: string; value: string }[]; totalCount: number }> {
    return this.propertyService
      .getList({
        name: params?.search,
        skipCount: params?.skipCount,
        maxResultCount: params?.maxResultCount ?? DEFAULT_MAX_RESULT_COUNT,
      })
      .pipe(
        map(response => ({
          items: response.items.map(item => ({
            key: String(item.id),
            value: item.name ?? String(item.id),
          })),
          totalCount: response.totalCount,
        })),
      );
  }

  loadHarvestBlockOptions(
    params?: ZnSelectQueryParams
  ): Observable<{ items: { key: string; value: string }[]; totalCount: number }> {
    return this.harvestBlockService
      .getList({
        name: params?.search,
        skipCount: params?.skipCount,
        maxResultCount: params?.maxResultCount ?? DEFAULT_MAX_RESULT_COUNT,
      })
      .pipe(
        map(response => ({
          items: response.items.map(item => ({
            key: String(item.id),
            value: item.name ?? String(item.id),
          })),
          totalCount: response.totalCount,
        })),
      );
  }

  loadProductivityParameterOptions(
    productivityParameterGroupName: string,
    params?: ZnSelectQueryParams
  ): Observable<{ items: { key: number; value: string }[]; totalCount: number }> {
    return this.productivityParameterService.getList({
      productivityParameterGroupId: [],
      productivityParameterGroupName,
      name: params?.search,
      skipCount: params?.skipCount,
      maxResultCount: params?.maxResultCount ?? DEFAULT_MAX_RESULT_COUNT,
    })
    .pipe(
      map(response => ({
        items: response.items.map(item => ({
          key: Number(item.id),
          value: item.name ?? String(item.id),
        })),
        totalCount: response.totalCount,
      })),
    );
  }

  loadMeasurementTypeOptions(params?: ZnSelectQueryParams): Observable<{ items: { key: number; value: string }[]; totalCount: number }> {
    return this.measurementTypeService.getList({
      name: params?.search,
        skipCount: params?.skipCount,
        maxResultCount: params?.maxResultCount ?? DEFAULT_MAX_RESULT_COUNT,
    })
    .pipe(
        map(response => ({
          items: response.items.map(item => ({
            key: Number(item.id),
            value: item.name ?? String(item.id),
          })),
          totalCount: response.totalCount,
        })),
      );
  }

  loadProductivityParamsGroups(): Observable<ProductivityParameterGroupDto[]> {
    return this.productivityParameterGroupService.getList({ maxResultCount: DEFAULT_MAX_RESULT_COUNT }).pipe(
      map(result => result.items),
    );
  }
}
